function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M15.728 8.315V2.929s0-2.596-2.663-2.596H2.935S.274.333.274 2.929v5.386s0 2.596 2.663 2.596h10.129s2.663 0 2.663-2.596zM11 5.632L5.94 8.53V2.735L11 5.632z" fill="#fff" /></svg>;
});